import { render, staticRenderFns } from "./ModalEventDelete.vue?vue&type=template&id=97218e36&scoped=true&"
import script from "./ModalEventDelete.vue?vue&type=script&lang=js&"
export * from "./ModalEventDelete.vue?vue&type=script&lang=js&"
import style0 from "./ModalEventDelete.vue?vue&type=style&index=0&id=97218e36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97218e36",
  null
  
)

export default component.exports